<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="直播主题" class="fn-left">
            <el-input v-model="listQuery.live_title" />
          </el-form-item>
          <el-form-item label="直播日期" class="fn-left">
            <el-date-picker v-model="listQuery.time" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime" />
          </el-form-item>
          <el-form-item label="适用年级" class="fn-left">
            <Select key="10" :selected.sync="listQuery.grade_id" :data="gradeLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="适用科目" class="fn-left">
            <Select key="5" :selected.sync="listQuery.subject_id" :data="subjectLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetLiveLists">查询</el-button>
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="fnAddPakcage()">添加</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="ID" prop="live_id" align="center" />
        <el-table-column label="直播主题" prop="live_title" align="center" />
        <el-table-column label="直播日期" prop="live_date" align="center" />
        <el-table-column label="直播时间段" align="center">
          <template slot-scope="{row}">
            <p>{{ row.start_time + "~" + row.end_time }}</p>
          </template>
        </el-table-column>
        <el-table-column label="适用年级" prop="grade_name" align="center" />
        <el-table-column label="适用科目" prop="subject_name" align="center" />
        <el-table-column label="适用教材" prop="book_name" align="center" />
        <el-table-column label="直播地址" prop="live_url" align="center">
          <!-- <template slot-scope="{row}">
            <p>{{ row.is_delete == 1 ? "关闭" : "开启" }}</p>
          </template> -->
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="fnToLiveSetting(row.live_id)">编辑</el-button>
            <el-button type="text" :loading="currentLoading == row.live_id" @click="fnDelete(row.live_id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="listQuery.total" :page-size="listQuery.limit" @current-change="fnGetLiveLists" />
    </div>

  </div>

</template>
<script>

import Select from '@/components/Select'
import commondata from '@/utils/commondata'
// import { validateRequire } from '@/utils/validate'

// import Tool from '@/assets/js/tool.js'

export default {
  name: 'TiYouYouPackageList',
  components: {
    Select
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      listQuery: {
        p: 1,
        limit: 20,
        live_title: '',
        subject_id: '',
        grade_id: '',
        begin_time: '',
        end_time: '',
        total: 0,
        time: ''
      },
      packageTypes: commondata.TYY_PACKAGE_TYPE,
      packageStatus: commondata.OPEN_STATUS,
      gradeLists: commondata.GRADE_LISTS,
      subjectLists: commondata.TYY_SUBJECT_LISTS,
      currentLoading: ''
    }
  },
  created() {
    this.fnGetLiveLists()
  },
  methods: {
    fnGetLiveLists: function() {
      this.bCreatePackage = false
      this.$http.tyyGetLiveList(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count)
        this.lists = res.data.list
      })
    },
    fnToLiveSetting(live_id) {
      this.$router.push({
        path: 'tiyouyouAddLive',
        query: { id: live_id }
      })
    },

    fnAddPakcage: function() {
      this.$router.push({
        path: 'tiyouyouAddLive'
      })
    },
    changeTime: function(val) {
      if (val != null) {
        this.listQuery.begin_time = val[0]
        this.listQuery.end_time = val[1]
      } else {
        this.listQuery.begin_time = ''
        this.listQuery.end_time = ''
        this.listQuery.time = []
      }
    },
    fnDelete(live_id) {
      this.$confirm('确认删除选中的直播么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.currentLoading = live_id
        this.$http.tyyDelLive({ live_id }).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            this.currentLoading = ''
            this.fnGetLiveLists()
          }
        })
      })
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
